import { PaymentLedger } from "@/shared/utils/interfaces";
import { useTranslation } from "react-i18next";
import TextfieldWithNumberBoard from "../Input/TextfieldWithNumberBoard";

type Props = {
  ledger: PaymentLedger;
  updateLedger: (itemId: number, ledger: Partial<PaymentLedger>) => void;
};

const SplitPaymentLedgerInputs = ({ ledger, updateLedger }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-rows-1 md:grid-cols-3 gap-2">
      <TextfieldWithNumberBoard
        value={ledger.payment_amount}
        setValue={(value) =>
          updateLedger(ledger.item_id, { payment_amount: value })
        }
        width={{ _: "100%", md: "15rem" }}
        placeholder={t("posOrders.price")}
        align="left"
      />

      <TextfieldWithNumberBoard
        value={ledger.payment_tip}
        setValue={(value) =>
          updateLedger(ledger.item_id, { payment_tip: value })
        }
        width={{ _: "100%", md: "15rem" }}
        placeholder={t("posOrders.tip")}
        align="left"
      />

      <TextfieldWithNumberBoard
        value={ledger.payment_service_fee}
        setValue={(value) =>
          updateLedger(ledger.item_id, { payment_service_fee: value })
        }
        width={{ _: "100%", md: "15rem" }}
        placeholder={t("posOrders.transactionFee")}
        align="left"
      />
    </div>
  );
};

export default SplitPaymentLedgerInputs;
